import {
  Box,
  Button,
  Container,
  Grid,
  IconButton,
  Tooltip,
  Typography,
} from "@mui/material";
import { TextFieldDisabled } from "../Components/TextFieldDisabled";
import { StatusIcon } from "../Components/StatusIcon";
import { MaterialReactTable } from "material-react-table";
import FileDownloadIcon from "@mui/icons-material/FileDownload";
import { ExportToCsv } from "export-to-csv"; //or use your library of choice here
import { useLocation, useNavigate } from "react-router-dom";
import { useState } from "react";
import { functions, instance, validateFunction } from "../Components/config";
import { DialogAlert } from "../Components/DialogAlert";
import FolderTwoToneIcon from "@mui/icons-material/FolderTwoTone";
import { useAuth } from "../Components/AuthContext";
import { MRT_Localization_ES } from "material-react-table/locales/es";
import { LoaderBox } from "../Components/LoaderBox";

const columns = [
  {
    accessorKey: "id",
    header: "ID",
    size: 5,
  },
  {
    accessorKey: "descripcion",
    header: "Descripción",
    size: 20,
  },
  {
    accessorKey: "meta",
    header: "Meta según PEI",
    size: 20,
  },
  {
    accessorKey: "resultado",
    header: "Resultado Esperado",
    size: 20,
  },
  {
    accessorKey: "responsable",
    header: "Responsable",
    size: 20,
  },
  {
    accessorKey: "unidades",
    header: "Unidad de Medida",
    size: 20,
  },
  {
    accessorKey: "porcentajes",
    header: "% por unidad",
    size: 20,
  },
  {
    accessorKey: "cantidades",
    header: "Cantidades",
    size: 10,
  },
  {
    accessorKey: "aprobado",
    header: "Presupuesto Aprobado",
    size: 10,
  },
  {
    accessorKey: "departamento",
    header: "Departamento",
    size: 10,
  },
  {
    accessorKey: "municipio",
    header: "Municipio",
    size: 10,
  },
  {
    accessorKey: "coordenadas",
    header: "Coordenadas",
    size: 10,
  },
  {
    accessorKey: "enero",
    header: "Enero",
    size: 10,
  },
  {
    accessorKey: "febrero",
    header: "Febrero",
    size: 10,
  },
  {
    accessorKey: "marzo",
    header: "Marzo",
    size: 10,
  },
  {
    accessorKey: "abril",
    header: "Abril",
    size: 10,
  },
  {
    accessorKey: "mayo",
    header: "Mayo",
    size: 10,
  },
  {
    accessorKey: "junio",
    header: "Junio",
    size: 10,
  },
  {
    accessorKey: "julio",
    header: "Julio",
    size: 10,
  },
  {
    accessorKey: "agosto",
    header: "Agosto",
    size: 10,
  },
  {
    accessorKey: "septiembre",
    header: "Septiembre",
    size: 10,
  },
  {
    accessorKey: "octubre",
    header: "Octubre",
    size: 10,
  },
  {
    accessorKey: "noviembre",
    header: "Noviembre",
    size: 10,
  },
  {
    accessorKey: "diciembre",
    header: "Diciembre",
    size: 10,
  },
];

function UPSE1() {
  const location = useLocation();
  const id = location.state?.id;
  const [openDialog, setOpenDialog] = useState(false);
  const [dialog, setDialog] = useState({
    title: "",
    text: "",
  });
  const [upse, setUPSE] = useState({});
  const [isLoading, setLoading] = useState(true);
  const [items, setItems] = useState([]);
  const navigate = useNavigate();
  const { user } = useAuth();

  const csvOptions = {
    filename: `UPSE_${id}_Actividades`,
    fieldSeparator: ";",
    quoteStrings: '"',
    decimalSeparator: ".",
    showLabels: true,
    useBom: true,
    useKeysAsHeaders: false,
    headers: columns.map((c) => c.header),
  };

  const csvExporter = new ExportToCsv(csvOptions);
  const handleExportRows = (rows) => {
    csvExporter.generateCsv(rows.map((row) => row.original));
  };

  const handleExportData = () => {
    csvExporter.generateCsv(items);
  };

  const handleToggle = () => {
    instance
      .patch(`/upse/toggleActivate`, {
        user: user.id,
        id: upse.id,
        activo: upse.activo,
      })
      .then((res) => {
        setDialog({
          title: "Aviso",
          text: `Se ha actualizado correctamente la capacidad de agregar actividades el UPSE`,
        });
        setOpenDialog(true);
        setUPSE({
          ...upse,
          activo: !upse.activo,
        });
      })
      .catch((err) => {
        if (err.response.status === 500) {
          setDialog({
            title: "ERROR",
            text: "Existe algún problema con el servidor, por favor inténtalo de nuevo mas tarde, si el problema persiste contáctate con alguno de los encargados.",
          });
        } else {
          setDialog({ title: "ERROR", text: err.response.data.message });
        }
        setOpenDialog(true);
      })
      .finally();
  };

  function populateTable() {
    instance
      .get("/actividad/getByUPSE/" + id)
      .then((res) => {
        let emptyMessage = "-";
        setItems(
          res.data.map((actividad) => {
            const seguimientos =
              actividad.seguimientos != null
                ? actividad.seguimientos.split(";|||//|||;")
                : [];
            const obj = {
              ...actividad,
              enero: seguimientos[0] ? seguimientos[0] : emptyMessage,
              febrero: seguimientos[1] ? seguimientos[1] : emptyMessage,
              marzo: seguimientos[2] ? seguimientos[2] : emptyMessage,
              abril: seguimientos[3] ? seguimientos[3] : emptyMessage,
              mayo: seguimientos[4] ? seguimientos[4] : emptyMessage,
              junio: seguimientos[5] ? seguimientos[5] : emptyMessage,
              julio: seguimientos[6] ? seguimientos[6] : emptyMessage,
              agosto: seguimientos[7] ? seguimientos[7] : emptyMessage,
              septiembre: seguimientos[8] ? seguimientos[8] : emptyMessage,
              octubre: seguimientos[9] ? seguimientos[9] : emptyMessage,
              noviembre: seguimientos[10] ? seguimientos[10] : emptyMessage,
              diciembre: seguimientos[11] ? seguimientos[11] : emptyMessage,
            };
            delete obj.seguimientos;
            return obj;
          })
        );
      })
      .catch((err) => {
        if (err.response.status === 500) {
          setDialog({
            title: "ERROR",
            text: "Existe algún problema con el servidor, por favor inténtalo de nuevo mas tarde, si el problema persiste contáctate con alguno de los encargados.",
          });
        } else {
          setDialog({ title: "ERROR", text: err.response.data.message });
        }
        setOpenDialog(true);
      })
      .finally();
  }

  function getItem() {
    instance
      .get("/upse/getById/" + id)
      .then((res) => {
        setUPSE(res.data);
      })
      .catch((err) => {
        if (err.response.status === 500) {
          setDialog({
            title: "ERROR",
            text: "Existe algún problema con el servidor, por favor inténtalo de nuevo mas tarde, si el problema persiste contáctate con alguno de los encargados.",
          });
        } else {
          setDialog({ title: "ERROR", text: err.response.data.message });
        }
        setOpenDialog(true);
      })
      .finally();
  }

  if (isLoading) {
    getItem();
    populateTable();
    setLoading(false);
  }
  return (
    <LoaderBox isLoading={isLoading}>
      <Container maxWidth="lg" sx={{ border: "1px solid #000", mt: 2 }}>
        <Grid container>
          <Grid item xs={12} sm={5}>
            <TextFieldDisabled title="Nombre" value={upse.nombre} />
          </Grid>
          <Grid item xs={12} sm={2}>
            <TextFieldDisabled
              title="Fecha de presentación"
              value={new Date(upse.fecha).toLocaleDateString("en-GB")}
            />
          </Grid>
          <Grid item xs={12} sm={2}>
            <TextFieldDisabled title="Año que planifica" value={upse.anio} />
          </Grid>
          <Grid item xs={12} sm={3}>
            <Box
              sx={{
                display: "flex",
                flexDirection: "column",
                padding: "16.5px 14px",
              }}
            >
              <Typography variant="overline">Cooperación Externa</Typography>
              <StatusIcon value={upse.cooperacion} />
            </Box>
          </Grid>
          <Grid item xs={12} sm={4}>
            <TextFieldDisabled title="Responsable" value={upse.responsable} />
          </Grid>
          <Grid item xs={12} sm={5}>
            <TextFieldDisabled
              title="Lugar de presentación"
              value={upse.lugar}
            />
          </Grid>
          <Grid item xs={12} sm={3}>
            <TextFieldDisabled
              title="Techo presupuestario"
              value={upse.presupuesto}
            />
          </Grid>
          <Grid item xs={12} sm={4}>
            <Grid item xs={12}>
              <TextFieldDisabled title="Tipo de eje" value={upse.tipoEje} />
            </Grid>
            <Grid item xs={12}>
              <TextFieldDisabled title="Eje" value={upse.eje} />
            </Grid>
          </Grid>
          <Grid item xs={12} sm={4}>
            <TextFieldDisabled
              title="Objetivo Estratégico"
              value={upse.estrategico}
            />
          </Grid>
          <Grid item xs={12} sm={4}>
            <TextFieldDisabled
              title="Objetivo Operativo"
              value={upse.operativo}
            />
          </Grid>
          <Grid
            item
            xs={12}
            sx={{ display: "flex", flexDirection: "row" }}
            marginBottom={2}
          >
            <Grid item xs={12} sm={6}>
              <Box sx={{ display: "flex", justifyContent: "center" }}>
                {validateFunction(user, functions.ModifyUPSE) && (
                  <Button
                    type="button"
                    variant="contained"
                    size="large"
                    className="warningBg"
                    onClick={() =>
                      navigate("/UPSE1Editar", { state: { id: id } })
                    }
                  >
                    Editar
                  </Button>
                )}
              </Box>
            </Grid>
            <Grid item xs={12} sm={6}>
              <Box sx={{ display: "flex", justifyContent: "center" }}>
                {validateFunction(user, functions.ToggleUPSEAddActivities) && (
                  <Button
                    type="button"
                    variant="contained"
                    size="large"
                    color={upse.activo ? "error" : "success"}
                    onClick={() => handleToggle()}
                  >
                    {upse.activo
                      ? "Deshabilitar agregar actividades"
                      : "Habilitar agregar actividades"}
                  </Button>
                )}
              </Box>
            </Grid>
          </Grid>
        </Grid>
      </Container>
      <Box
        sx={{
          width: "100%",
          display: "flex",
          justifyContent: "center",
          mt: 2,
          mb: 2,
        }}
      >
        <Typography variant="h6" gutterBottom>
          Actividades relacionadas
        </Typography>
      </Box>
      <MaterialReactTable
        localization={MRT_Localization_ES}
        columns={columns}
        data={items}
        //enableRowSelection
        enableHiding={false}
        enableDensityToggle={false}
        initialState={{
          showColumnFilters: false,
          columnVisibility: {
            id: false,
          },
        }}
        //La siguiente propiedad coloca el acceso al detalle de la actividad al final de la fila.
        //positionActionsColumn="last"
        displayColumnDefOptions={{
          "mrt-row-actions": {
            header: "", //change header text
          },
        }}
        enableRowActions
        renderRowActions={({ row, table }) => (
          <Box sx={{ display: "flex", flexWrap: "nowrap", gap: "8px" }}>
            <Tooltip title="Detalle de la actividad">
              <IconButton
                color="primary"
                onClick={() =>
                  navigate("/Actividad", {
                    state: { id: row.original.id },
                  })
                }
              >
                <FolderTwoToneIcon />
              </IconButton>
            </Tooltip>
          </Box>
        )}
        positionToolbarAlertBanner="bottom"
        renderTopToolbarCustomActions={({ table }) => (
          <Box
            sx={{ display: "flex", gap: "1rem", p: "0.5rem", flexWrap: "wrap" }}
          >
            <Button
              color="primary"
              //export all data that is currently in the table (ignore pagination, sorting, filtering, etc.)
              onClick={handleExportData}
              startIcon={<FileDownloadIcon />}
              variant="contained"
            >
              Exportar
            </Button>
            {/* <Button
              disabled={
                !table.getIsSomeRowsSelected() && !table.getIsAllRowsSelected()
              }
              //only export selected rows
              onClick={() => handleExportRows(table.getSelectedRowModel().rows)}
              startIcon={<FileDownloadIcon />}
              variant="contained"
            >
              Exportar filas seleccionadas
            </Button> */}
          </Box>
        )}
      />
      <DialogAlert
        title={dialog.title}
        text={dialog.text}
        open={openDialog}
        setOpen={setOpenDialog}
        redirectOnClose={dialog.redirect}
        page={dialog.page}
        pageState={dialog.pageState}
      />
    </LoaderBox>
  );
}

export { UPSE1 };
